import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { api } from "../../components/api/api";
import { Alert, AlertErro } from "../../util/Alertas";

const BaixaBoleto = () => {
    const [file, setFile] = useState(null);
    const [headers, setHeaders] = useState([]);
    const [data, setData] = useState([]);

    useEffect(() => {
        const loader = document.getElementById("loader-page");
        if (loader) loader.style.display = "none";
    }, []);

    const handleFile = (uploadedFile) => {
        setFile(uploadedFile);

        const reader = new FileReader();
        reader.onload = (e) => {
            const binary = e.target.result;
            const workbook = XLSX.read(binary, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            setHeaders(json[0] || []);
            setData(json.slice(1));
        };

        reader.readAsBinaryString(uploadedFile);
    };

    const onDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files.length) {
            handleFile(e.dataTransfer.files[0]);
        }
    };

    const downloadTxt = (conteudo, nomeArquivo = 'arquivo.txt') => {
        const blob = new Blob([conteudo], { type: 'text/plain;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = nomeArquivo;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const enviarParaApi = async () => {
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        api.post('/Arquivo/BaixaBoleto', formData, res => {
            if (res.data.length > 0) {
                Alert(res.data.join('<br />'), true, true, true);
                downloadTxt(res.data.join('\n\n'), 'erros_importa_baixa_excel.txt')
            }
        }, err => {
            console.clear()
            console.log(err)
            AlertErro(err, 'Erro ao importar o arquivo')
        })
    };

    return (
        <section className="app">
            <div className="content">
                <h1 className="text-2xl font-bold mb-6">
                    Importar planilha de boletos
                </h1>

                {/* Upload */}
                <div
                    onDrop={onDrop}
                    onDragOver={(e) => e.preventDefault()}
                    className="border-2 border-dashed border-gray-400 bg-white rounded-xl p-8 text-center cursor-pointer hover:border-blue-500 transition"
                >
                    <input
                        type="file"
                        accept=".xlsx,.xls"
                        id="fileUpload"
                        className="hidden"
                        onChange={(e) => {
                            if (e.target.files && e.target.files.length > 0) {
                                handleFile(e.target.files[0]);
                            }
                        }}
                    />

                    <label htmlFor="fileUpload" className="cursor-pointer">
                        <p className="text-lg font-medium">
                            Arraste e solte o arquivo aqui
                        </p>
                        <p className="text-sm text-gray-500 mt-2">
                            ou clique para importar
                        </p>
                    </label>
                    {/* Enviar */}
                </div>
                {data.length > 0 && <div style={{ margin: 2 }} className="flex justify-end">
                    <button
                        onClick={enviarParaApi}
                        className="btn btn-primary"
                    >
                        Enviar
                    </button>
                </div>}
                {/* Preview */}
                {data.length > 0 && (
                    <>
                        <div className="mt-8 overflow-x-auto bg-white rounded-xl shadow">
                            <table className="min-w-full border">
                                <thead className="bg-gray-200">
                                    <tr>
                                        {headers.map((h, index) => (
                                            <th
                                                key={index}
                                                className="px-4 py-2 text-left text-sm font-semibold border"
                                            >
                                                {h}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((row, rowIndex) => (
                                        <tr key={rowIndex} className="border-t">
                                            {row.map((cell, cellIndex) => (
                                                <td
                                                    key={cellIndex}
                                                    className="px-4 py-2 text-sm border"
                                                >
                                                    {cell}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
        </section>
    );
};

export default BaixaBoleto;
